module.exports = __webpack_public_path__ + "static/media/zoom_in.bbe7ccf1.svg";